// Portfolio — bajarilgan real loyihalar (49 ta).
// Rasmlar: public/assets/img/projects/*.webp
const dataProject = [
    {
        id: 1,
        slug: "grandpharm",
        title: { uz: "Grandpharm — logistika ekotizimi", ru: "Grandpharm — логистическая экосистема" },
        category: { uz: "Meditsina", ru: "Медицина" },
        tech: ["TypeScript", "Next.js", "Nest.js"],
        url: "https://grandpharm.uz/",
        img: "/assets/img/projects/grandpharm.webp",
    },
    {
        id: 2,
        slug: "tezlift",
        title: { uz: "Tez Lift — lift servisi avtomatlashtirilishi", ru: "Tez Lift — автоматизация лифтового сервиса" },
        category: { uz: "Biznes", ru: "Бизнес" },
        tech: ["TypeScript", "Next.js", "Nest.js"],
        url: "",
        img: "/assets/img/projects/tezlift.webp",
    },
    {
        id: 3,
        slug: "rememberme",
        title: { uz: "RememberMe", ru: "RememberMe" },
        category: { uz: "Boshqalar", ru: "Другие" },
        tech: ["TypeScript", "Next.js", "Nest.js"],
        url: "https://rememberme.uz",
        img: "/assets/img/projects/rememberme.webp",
    },
    {
        id: 4,
        slug: "atlet",
        title: { uz: "Atlet", ru: "Atlet" },
        category: { uz: "Sport", ru: "Спорт" },
        tech: ["Next.js", "Tailwind CSS"],
        url: "https://atlet.uz",
        img: "/assets/img/projects/atlet.webp",
    },
    {
        id: 5,
        slug: "befitpro",
        title: { uz: "BEFIT PRO — yetkazib berish tizimi", ru: "BEFIT PRO — система доставки" },
        category: { uz: "Sport", ru: "Спорт" },
        tech: ["TypeScript", "Next.js", "Nest.js"],
        url: "",
        img: "/assets/img/projects/befitpro.webp",
    },
    {
        id: 6,
        slug: "serkon-east",
        title: { uz: "Serkon East", ru: "Serkon East" },
        category: { uz: "Biznes", ru: "Бизнес" },
        tech: ["TypeScript", "Next.js", "Nest.js"],
        url: "https://serkon.uz/",
        img: "/assets/img/projects/serkon-east.webp",
    },
    {
        id: 7,
        slug: "suvmash-jsc",
        title: { uz: "SUVMASH JSC", ru: "SUVMASH JSC" },
        category: { uz: "Qurilish", ru: "Строительство" },
        tech: ["Nest.js", "Next.js", "Tailwind CSS"],
        url: "https://suvmash.uz",
        img: "/assets/img/projects/suvmash-jsc.webp",
    },
    {
        id: 8,
        slug: "logistatrans",
        title: { uz: "LogistaTrans", ru: "LogistaTrans" },
        category: { uz: "Biznes", ru: "Бизнес" },
        tech: ["TypeScript", "Next.js", "Nest.js"],
        url: "https://logistatrans.com",
        img: "/assets/img/projects/logistatrans.webp",
    },
    {
        id: 9,
        slug: "anibla",
        title: { uz: "Anibla (mobil ilova)", ru: "Anibla (мобильное приложение)" },
        category: { uz: "Media", ru: "Медиа" },
        tech: ["React Native", "Nest.js", "MongoDB"],
        url: "https://play.google.com/store/apps/details?id=com.amediatv.soft",
        img: "/assets/img/projects/anibla.webp",
    },
    {
        id: 10,
        slug: "yurak-markazi",
        title: { uz: "Yurak Markazi", ru: "Yurak Markazi" },
        category: { uz: "Meditsina", ru: "Медицина" },
        tech: ["TypeScript", "Next.js", "Nest.js"],
        url: "https://yurakmarkazi.uz",
        img: "/assets/img/projects/yurak-markazi.webp",
    },
    {
        id: 11,
        slug: "logistatrans-app",
        title: { uz: "Logistatrans (mobil ilova)", ru: "Logistatrans (мобильное приложение)" },
        category: { uz: "Biznes", ru: "Бизнес" },
        tech: ["React Native", "TypeScript", "Nest.js"],
        url: "https://play.google.com/store/apps/details?id=uz.logistatrans.app",
        img: "/assets/img/projects/logistatrans-app.webp",
    },
    {
        id: 12,
        slug: "ung-academy",
        title: { uz: "UNG Academy", ru: "UNG Academy" },
        category: { uz: "Boshqalar", ru: "Другие" },
        tech: ["TypeScript", "Next.js", "Nest.js"],
        url: "https://www.ung.academy",
        img: "/assets/img/projects/ung-academy.webp",
    },
    {
        id: 13,
        slug: "shayana-farm",
        title: { uz: "Shayana Farm", ru: "Shayana Farm" },
        category: { uz: "Meditsina", ru: "Медицина" },
        tech: ["Next.js", "TypeScript", "Tailwind CSS"],
        url: "https://shayanafarm.com/",
        img: "/assets/img/projects/shayana-farm.webp",
    },
    {
        id: 14,
        slug: "tamerlan-marketing",
        title: { uz: "Tamerlan Marketing", ru: "Tamerlan Marketing" },
        category: { uz: "Internet do'kon", ru: "Интернет-магазин" },
        tech: ["TypeScript", "Next.js", "Nest.js"],
        url: "https://tamerlan-marketing.uz",
        img: "/assets/img/projects/tamerlan-marketing.webp",
    },
    {
        id: 15,
        slug: "besh-market-app",
        title: { uz: "Besh Market (mobil ilova)", ru: "Besh Market (мобильное приложение)" },
        category: { uz: "Internet do'kon", ru: "Интернет-магазин" },
        tech: ["React Native", "TypeScript", "Nest.js"],
        url: "https://play.google.com/store/apps/details?id=com.beshmarket",
        img: "/assets/img/projects/besh-market-app.webp",
    },
    {
        id: 16,
        slug: "sts-market",
        title: { uz: "STS Market", ru: "STS Market" },
        category: { uz: "Internet do'kon", ru: "Интернет-магазин" },
        tech: ["React", "Next.js", "Tailwind CSS"],
        url: "https://www.stsmarket.uz/ru",
        img: "/assets/img/projects/sts-market.webp",
    },
    {
        id: 17,
        slug: "family-group",
        title: { uz: "Family Group", ru: "Family Group" },
        category: { uz: "Biznes", ru: "Бизнес" },
        tech: ["Next.js", "TypeScript", "Tailwind CSS"],
        url: "",
        img: "/assets/img/projects/family-group.webp",
    },
    {
        id: 18,
        slug: "mesmer",
        title: { uz: "Mesmer", ru: "Mesmer" },
        category: { uz: "Qurilish", ru: "Строительство" },
        tech: ["React", "Next.js", "Tailwind CSS"],
        url: "https://mesmer.uz/en",
        img: "/assets/img/projects/mesmer.webp",
    },
    {
        id: 19,
        slug: "biolife",
        title: { uz: "Biolife", ru: "Biolife" },
        category: { uz: "Boshqalar", ru: "Другие" },
        tech: ["Next.js", "Tailwind CSS", "TypeScript"],
        url: "https://biolife.innobek.uz",
        img: "/assets/img/projects/biolife.webp",
    },
    {
        id: 20,
        slug: "bobo-market-app",
        title: { uz: "Bobo Market (mobil ilova)", ru: "Bobo Market (мобильное приложение)" },
        category: { uz: "Internet do'kon", ru: "Интернет-магазин" },
        tech: ["React Native", "TypeScript", "Nest.js"],
        url: "https://play.google.com/store/apps/details?id=uz.bobo.market",
        img: "/assets/img/projects/bobo-market-app.webp",
    },
    {
        id: 21,
        slug: "elma-lms",
        title: { uz: "ELMA — xodimlarni o'qitish tizimi", ru: "ELMA — система обучения сотрудников" },
        category: { uz: "Biznes", ru: "Бизнес" },
        tech: ["Next.js", "TypeScript", "Nest.js"],
        url: "",
        img: "/assets/img/projects/elma-lms.webp",
    },
    {
        id: 22,
        slug: "gci",
        title: { uz: "GCI", ru: "GCI" },
        category: { uz: "Boshqalar", ru: "Другие" },
        tech: ["TypeScript", "Next.js", "Tailwind CSS"],
        url: "https://gci-labs.uz",
        img: "/assets/img/projects/gci.webp",
    },
    {
        id: 23,
        slug: "dentium",
        title: { uz: "Dentium", ru: "Dentium" },
        category: { uz: "Meditsina", ru: "Медицина" },
        tech: ["React", "jQuery", "Tailwind CSS"],
        url: "https://www.dentium.uz/",
        img: "/assets/img/projects/dentium.webp",
    },
    {
        id: 24,
        slug: "drkim",
        title: { uz: "DrKim", ru: "DrKim" },
        category: { uz: "Meditsina", ru: "Медицина" },
        tech: ["React", "jQuery", "CSS"],
        url: "https://www.drkim.uz/",
        img: "/assets/img/projects/drkim.webp",
    },
    {
        id: 25,
        slug: "myyurist-app",
        title: { uz: "My Yurist (mobil ilova)", ru: "My Yurist (мобильное приложение)" },
        category: { uz: "Boshqalar", ru: "Другие" },
        tech: ["React Native", "TypeScript", "Nest.js"],
        url: "https://play.google.com/store/apps/details?id=com.yurist_mobile",
        img: "/assets/img/projects/myyurist-app.webp",
    },
    {
        id: 26,
        slug: "oikos",
        title: { uz: "Oikos", ru: "Oikos" },
        category: { uz: "Qurilish", ru: "Строительство" },
        tech: ["TypeScript", "Next.js", "Nest.js"],
        url: "https://oikos-paint.uz",
        img: "/assets/img/projects/oikos.webp",
    },
    {
        id: 27,
        slug: "ipsum-conference",
        title: { uz: "Ipsum Conference", ru: "Ipsum Conference" },
        category: { uz: "Meditsina", ru: "Медицина" },
        tech: ["Next.js", "Tailwind CSS", "TypeScript"],
        url: "https://ipsumconference.uz",
        img: "/assets/img/projects/ipsum-conference.webp",
    },
    {
        id: 28,
        slug: "sbm-food",
        title: { uz: "SBM Food", ru: "SBM Food" },
        category: { uz: "Internet do'kon", ru: "Интернет-магазин" },
        tech: ["TypeScript", "Next.js", "Nest.js"],
        url: "https://sbmfood.uz",
        img: "/assets/img/projects/sbm-food.webp",
    },
    {
        id: 29,
        slug: "firewise-app",
        title: { uz: "FireWise (mobil ilova)", ru: "FireWise (мобильное приложение)" },
        category: { uz: "Biznes", ru: "Бизнес" },
        tech: ["React Native", "TypeScript", "Nest.js"],
        url: "https://play.google.com/store/apps/details?id=uz.firewise.app",
        img: "/assets/img/projects/firewise-app.webp",
    },
    {
        id: 30,
        slug: "neurotagline",
        title: { uz: "Neurotagline", ru: "Neurotagline" },
        category: { uz: "Meditsina", ru: "Медицина" },
        tech: ["TypeScript", "Next.js", "Nest.js"],
        url: "https://neurotagline.com",
        img: "/assets/img/projects/neurotagline.webp",
    },
    {
        id: 31,
        slug: "myyurist",
        title: { uz: "MyYurist", ru: "MyYurist" },
        category: { uz: "Boshqalar", ru: "Другие" },
        tech: ["TypeScript", "Next.js", "Nest.js"],
        url: "https://myyurist.uz",
        img: "/assets/img/projects/myyurist.webp",
    },
    {
        id: 32,
        slug: "ceragem-uzbekistan",
        title: { uz: "Ceragem Uzbekistan", ru: "Ceragem Uzbekistan" },
        category: { uz: "Meditsina", ru: "Медицина" },
        tech: ["Next.js", "React", "TypeScript"],
        url: "https://www.ceragemuzbekistann.uz/",
        img: "/assets/img/projects/ceragem-uzbekistan.webp",
    },
    {
        id: 33,
        slug: "firewise",
        title: { uz: "Firewise", ru: "Firewise" },
        category: { uz: "Biznes", ru: "Бизнес" },
        tech: ["Nest.js", "Next.js", "MongoDB"],
        url: "https://firewise.uz",
        img: "/assets/img/projects/firewise.webp",
    },
    {
        id: 34,
        slug: "imtihan",
        title: { uz: "Imtihan", ru: "Imtihan" },
        category: { uz: "Boshqalar", ru: "Другие" },
        tech: ["TypeScript", "Next.js", "Nest.js"],
        url: "https://imtihan.net",
        img: "/assets/img/projects/imtihan.webp",
    },
    {
        id: 35,
        slug: "freeman-lourenco",
        title: { uz: "Freeman & Lourenco", ru: "Freeman & Lourenco" },
        category: { uz: "Boshqalar", ru: "Другие" },
        tech: ["Next.js", "Tailwind CSS", "TypeScript"],
        url: "https://site1760185143.mywhc.ca",
        img: "/assets/img/projects/freeman-lourenco.webp",
    },
    {
        id: 36,
        slug: "decolor",
        title: { uz: "Decolor", ru: "Decolor" },
        category: { uz: "Qurilish", ru: "Строительство" },
        tech: ["Next.js", "Tailwind CSS", "TypeScript"],
        url: "https://decolor.uz",
        img: "/assets/img/projects/decolor.webp",
    },
    {
        id: 37,
        slug: "bernhardt",
        title: { uz: "Bernhardt", ru: "Bernhardt" },
        category: { uz: "Internet do'kon", ru: "Интернет-магазин" },
        tech: ["Next.js", "Tailwind CSS", "Lucide"],
        url: "https://bernhardt.uz",
        img: "/assets/img/projects/bernhardt.webp",
    },
    {
        id: 38,
        slug: "wogme",
        title: { uz: "Wogme", ru: "Wogme" },
        category: { uz: "Internet do'kon", ru: "Интернет-магазин" },
        tech: ["React", "Next.js", "MUI"],
        url: "https://www.wogme.com/",
        img: "/assets/img/projects/wogme.webp",
    },
    {
        id: 39,
        slug: "ceragemuzbekistann",
        title: { uz: "Ceragem Uzbekistan", ru: "Ceragem Uzbekistan" },
        category: { uz: "Biznes", ru: "Бизнес" },
        tech: ["React", "Next.js", "Tailwind CSS"],
        url: "https://www.ceragemuzbekistann.uz",
        img: "/assets/img/projects/ceragemuzbekistann.webp",
    },
    {
        id: 40,
        slug: "uzfiltr",
        title: { uz: "UzFiltr", ru: "UzFiltr" },
        category: { uz: "Qurilish", ru: "Строительство" },
        tech: ["React", "Express.js", "Node.js"],
        url: "https://www.uzfiltr.uz/",
        img: "/assets/img/projects/uzfiltr.webp",
    },
    {
        id: 41,
        slug: "zap",
        title: { uz: "Zap", ru: "Zap" },
        category: { uz: "Boshqalar", ru: "Другие" },
        tech: ["TypeScript", "Next.js", "Nest.js"],
        url: "https://zap.uz",
        img: "/assets/img/projects/zap.webp",
    },
    {
        id: 42,
        slug: "scriber-arts",
        title: { uz: "Scriber Arts", ru: "Scriber Arts" },
        category: { uz: "Qurilish", ru: "Строительство" },
        tech: ["TypeScript", "Next.js", "Nest.js"],
        url: "https://scriber-arts.uz",
        img: "/assets/img/projects/scriber-arts.webp",
    },
    {
        id: 43,
        slug: "cleanza",
        title: { uz: "Cleanza", ru: "Cleanza" },
        category: { uz: "Biznes", ru: "Бизнес" },
        tech: ["React", "Next.js", "TypeScript"],
        url: "https://www.cleanza.uz/",
        img: "/assets/img/projects/cleanza.webp",
    },
    {
        id: 44,
        slug: "anibla-web",
        title: { uz: "Anibla.uz (veb platforma)", ru: "Anibla.uz (веб-платформа)" },
        category: { uz: "Media", ru: "Медиа" },
        tech: ["Next.js", "TypeScript", "Tailwind CSS"],
        url: "https://anibla.uz/",
        img: "/assets/img/projects/anibla-web.webp",
    },
    {
        id: 45,
        slug: "global-building-group",
        title: { uz: "Global Building Group", ru: "Global Building Group" },
        category: { uz: "Qurilish", ru: "Строительство" },
        tech: ["Next.js", "TypeScript", "Tailwind CSS"],
        url: "https://globalbuilding.uz/",
        img: "/assets/img/projects/global-building-group.webp",
    },
    {
        id: 46,
        slug: "ipsum-pathology",
        title: { uz: "IPSUM Pathology", ru: "IPSUM Pathology" },
        category: { uz: "Meditsina", ru: "Медицина" },
        tech: ["Next.js", "TypeScript", "Tailwind CSS"],
        url: "https://ipsum.uz/",
        img: "/assets/img/projects/ipsum-pathology.webp",
    },
    {
        id: 47,
        slug: "ung-overseas",
        title: { uz: "UNG Overseas", ru: "UNG Overseas" },
        category: { uz: "Biznes", ru: "Бизнес" },
        tech: ["Next.js", "TypeScript", "Tailwind CSS"],
        url: "https://www.ungoverseas.com/",
        img: "/assets/img/projects/ung-overseas.webp",
    },
    {
        id: 48,
        slug: "mountain-and-sea",
        title: { uz: "Mountain & Sea", ru: "Mountain & Sea" },
        category: { uz: "Biznes", ru: "Бизнес" },
        tech: ["Next.js", "TypeScript", "Tailwind CSS"],
        url: "https://mountainandsea.uz/",
        img: "/assets/img/projects/mountain-and-sea.webp",
    },
    {
        id: 49,
        slug: "avantika-medex",
        title: { uz: "Avantika Medex", ru: "Avantika Medex" },
        category: { uz: "Meditsina", ru: "Медицина" },
        tech: ["Next.js", "TypeScript", "Tailwind CSS"],
        url: "https://avantikamedex.uz/",
        img: "/assets/img/projects/avantika-medex.webp",
    },
]

export default dataProject;
